var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('div',{staticClass:"analysis-page__container"},[_c('h1',[_vm._v("Analysis")]),_c('div',{staticClass:"analysis-content"},[_c('AnalysisDropdowns'),_c('router-view')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }